import { render, staticRenderFns } from "./FNews.vue?vue&type=template&id=35261ad4&"
import script from "./FNews.vue?vue&type=script&lang=js&"
export * from "./FNews.vue?vue&type=script&lang=js&"
import style0 from "./FNews.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports